import {
  ExpertApplication, Qualifications
} from "redux/models/expertProfile";
import { AppThunk } from "redux/store";
import {
  addRemoveLanguagesRequest,
  addRemoveMediumOfContactRequest,
  changeExpertProfile,
  changeLanguagessData,
  changeMediumOfContactData,
  expertProfileActionFailure,
  expertProfileActionRequest,
  expertProfileActionSuccess,
  FormType,
  getExpertProfileSuccess,
  StatusType,
  validateExpertProfileForm,
  addRemoveQualifications,
  addRemoveLanguages,
  contactUsRequest,
  contactUsSuccess,
  contactUsFailure,
  resetExpertForm
} from "redux/reducers/expertProfile";

import expertProfileService from "services/expertProfile";
import { triggerAlert } from "redux/reducers/appSlice";
import { ExpertProfileSaveType } from "../../services/service-models/expertProfile";
import RoutePaths from "routes/RoutePaths";
import { translateFrontEndAlerts } from "../../utils/translation";
import { getAuthUserProfile } from "redux/actions";

export const setExpertProfileData =
  (key: string, value: string, error: string | null): AppThunk =>
    (dispatch) => {
      dispatch(changeExpertProfile({ key, value, error }));
    };

export const getExpertProfile = (): AppThunk => async (dispatch, getState) => {
  try {
    dispatch(expertProfileActionRequest());
    const data = await expertProfileService.expertProfileGet();
    if (data) {
      dispatch(getExpertProfileSuccess(data?.data?.data));
    } else {
      dispatch(expertProfileActionFailure());
    }
  } catch (e) {
    dispatch(expertProfileActionFailure());
  }
};

export const saveExpertProfile =
  (
    profile: ExpertApplication,
    status: ExpertProfileSaveType,
    formType: FormType,
    callback: any
  ): AppThunk =>
    async (dispatch, getState) => {
      try {
        dispatch(expertProfileActionRequest());
        let success_message = "";
        // @ts-ignore
        const form: any = new FormData();
        if (profile.id) form.append("id", profile.id);
        form.append("first_name", profile.first_name.value);
        form.append("last_name", profile.last_name.value);
        form.append("country_id", profile.country_id.value);
        form.append("address", profile.address.value);
        form.append("mail", profile.email.value);
        form.append("contact_no", profile.telephone.value);
        form.append("meeting_url", profile.zoom_link.value);
        if (profile.career_summary?.value) {
          form.append("career_summary", profile.career_summary.value);
        }
        if (Array.isArray(profile?.contact_medium)) {
          profile?.contact_medium?.forEach((el, inx) => {
            if (el.medium !== "")
              form.append(`contacts[${inx}][type]`, el.medium);
            if (el.value) form.append(`contacts[${inx}][contact]`, el.value);
          });
        }
        if (Array.isArray(profile?.qualifications)) {
          profile?.qualifications?.forEach((qualification: Qualifications, inx) => {
            form.append(
              `qualifications[${inx}][qualifiction_type]`,
              qualification.type ?? ""
            );
            form.append(`qualifications[${inx}][title]`, qualification.title || "");
            form.append(
              `qualifications[${inx}][certificate]`,
              qualification.certification || qualification.oldCertification?.certification || ""
            );
            form.append(
              `qualifications[${inx}][old_certification_remove]`,
              qualification.oldCertification?.disable ? "1" : "0"
            );
          });
        }
        if (Array.isArray(profile?.languages)) {
          profile?.languages?.forEach((el: any, inx) => {
            if (el.language !== "" || el.level !== "") {
              form.append(`languages[${inx}][language]`, el.language || "");
              form.append(`languages[${inx}][level]`, el.level || "");
            }
          });
        }
        form.append(
          Array.isArray(profile?.certificate1) &&
          profile?.certificate1.length > 0 &&
          profile?.certificate1?.[0].type
            ? profile?.certificate1?.[0].type
            : "",
          Array.isArray(profile?.certificate1)
          && profile?.certificate1.length > 0
          && profile?.certificate1?.[0].file
            ? profile.certificate1[0].file
            : (!profile?.certificate1[0]?.oldCertificate?.disable
              && profile?.certificate1[0]?.oldCertificate?.certificate)
              ? profile.certificate1[0].oldCertificate.certificate
              : ""
        );

        form.append(
          Array.isArray(profile?.certificate2)
          && profile?.certificate2.length > 0
          && profile?.certificate2?.[0].type
            ? profile?.certificate2?.[0].type
            : "",
          Array.isArray(profile?.certificate2)
          && profile?.certificate2.length > 0
          && profile?.certificate2?.[0].file
            ? profile.certificate2[0].file
            : (!profile?.certificate2[0]?.oldCertificate?.disable
              && profile?.certificate2[0]?.oldCertificate?.certificate)
              ? profile.certificate2[0].oldCertificate.certificate
              : ""
        );

        if (formType === FormType.CREATE && profile.status === null) {
          const res = await expertProfileService.expertProfileCreate(form);
          if (res?.statusCode === 201) dispatch(getAuthUserProfile());
          success_message =
            status === ExpertProfileSaveType.apply
              ? translateFrontEndAlerts(14001)
              : translateFrontEndAlerts(14002);
        } else if (
          formType === FormType.CREATE &&
          profile.status === StatusType.SAVE_DRAFT
        ) {
          await expertProfileService.expertProfileUpdate(form);
          success_message =
            status === ExpertProfileSaveType.apply
              ? translateFrontEndAlerts(14003)
              : translateFrontEndAlerts(14004);
        } else if (
          formType === FormType.UPDATE &&
          profile.status === StatusType.APPLY &&
          status === ExpertProfileSaveType.apply
        ) {
          await expertProfileService.expertProfileUpdate(form);
          success_message =
            status === ExpertProfileSaveType.apply
              ? translateFrontEndAlerts(14003)
              : translateFrontEndAlerts(14004);
        } else {
          dispatch(
            triggerAlert({
              type: "error",
              children: translateFrontEndAlerts(14007)
            })
          );
        }
        dispatch(expertProfileActionSuccess());
        dispatch(getExpertProfile());
        dispatch(
          triggerAlert({
            type: "success",
            children: success_message
          })
        );

        formType === FormType.UPDATE
          ? callback(RoutePaths.expertView)
          : callback(RoutePaths.expertRegisterSuccess);
      } catch (e) {
        const errorMessage =
          formType === FormType.UPDATE || status === ExpertProfileSaveType.save
            ? translateFrontEndAlerts(14008)
            : translateFrontEndAlerts(14007);
        dispatch(expertProfileActionFailure());
        dispatch(
          triggerAlert({
            type: "error",
            children: errorMessage
          })
        );
        return false;
      }
    };

export const addMediumOfContact =
  (index: number): AppThunk =>
    (dispatch) => {
      dispatch(addRemoveMediumOfContactRequest(index));
    };

export const mediumOfContactData =
  (data: any): AppThunk =>
    (dispatch) => {
      dispatch(changeMediumOfContactData(data));
    };

export const qualificationsAddRemove =
  (data: any): AppThunk =>
    (dispatch) => {
      dispatch(addRemoveQualifications(data));
    };

export const languagesAddRemove =
  (index: number): AppThunk =>
    (dispatch) => {
      dispatch(addRemoveLanguagesRequest(index));
    };

export const languageDataChange =
  (data: any): AppThunk =>
    (dispatch) => {
      dispatch(changeLanguagessData(data));
    };
export const validateExpertProfile =
  (data: ExpertApplication): AppThunk =>
    (dispatch) => {
      dispatch(validateExpertProfileForm(data));
    };

export const alterLanguages =
  (data: any): AppThunk =>
    (dispatch) => {
      dispatch(addRemoveLanguages(data));
    };

export const resetForm =
  (): AppThunk =>
    (dispatch) => {
      dispatch(resetExpertForm());
    };

export const contactUs =
  (obj: any): AppThunk =>
    async (dispatch, getState) => {
      try {
        dispatch(contactUsRequest());
        const data = await expertProfileService.contactUs(obj);
        if (data) {
          dispatch(
            triggerAlert({
              type: "success",
              children: "success"
            })
          );
          dispatch(contactUsSuccess());
          return data;
        }
      } catch (e) {
        dispatch(contactUsFailure());
        return e;
      }
    };
